<template lang="pug">
#review-actions-organization-owner-card.card.organization-owner-card
  .d-flex.align-items-start.justify-content-between.gap-3
    .flex-grow-1
      .d-flex.align-items-center.gap-2.organization-owner-card__header.mb-1(
        :class='headerStateClass'
      )
        icon.organization-owner-card__icon(:key='iconName' :name='iconName')
        h6.organization-owner-card__title.mb-0 {{ reviewItem.organizationName }}
      .organization-owner-card__meta-row(
        v-if='reviewItem.usersCount !== undefined || reviewItem.action'
      )
        p.organization-owner-card__meta.mb-0(
          v-if='reviewItem.action === "transfer"'
        )
          strong
          | {{ $t('modal.deleteAccountReviewActionsOrganizationsModal.card.selectedNewOwner', { newOwnerName: reviewItem.newOwnerName, newOwnerEmail: reviewItem.newOwnerEmail }) }}
        p.organization-owner-card__meta.mb-0(
          v-if='reviewItem.usersCount !== undefined'
        )
          strong {{ placeholderUsersCount }}
          |
          | {{ placeholderUsers }}
        info-pill.organization-owner-card__pill(
          :class='pillStateClass'
          :key='reviewItem.organizationId'
          v-if='reviewItem.action'
        )
          | {{ placeholderPill }}
</template>
<script>
import Icon from '@/ui/atoms/Icon.vue';
import InfoPill from '@/modules/business/components/molecules/InfoPill.vue';

export default {
  name: 'ReviewActionsOrganizationOwnerCard',
  components: {
    InfoPill,
    Icon,
  },
  props: {
    reviewItem: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    placeholderPill() {
      switch (this.reviewItem.action) {
        case 'transfer':
          return this.$t(
            'modal.deleteAccountReviewActionsOrganizationsModal.card.transfer'
          );
        case 'delete':
          return this.$t(
            'modal.deleteAccountReviewActionsOrganizationsModal.card.delete'
          );
        case 'leave':
          return this.$t(
            'modal.deleteAccountReviewActionsOrganizationsModal.card.leave'
          );
        default:
          return '';
      }
    },
    placeholderUsers() {
      return this.reviewItem.action === 'delete'
        ? this.$t(
            'modal.deleteAccountReviewActionsOrganizationsModal.card.removedUsers'
          )
        : this.$t(
            'modal.deleteAccountReviewActionsOrganizationsModal.card.usersCount'
          );
    },
    placeholderUsersCount() {
      return this.reviewItem.action === 'delete'
        ? this.reviewItem.usersCount
        : this.reviewItem.usersCount - 1;
    },
    iconName() {
      if (this.reviewItem.action === 'delete') {
        return 'trash-can';
      }
      return 'user-unlock';
    },
    headerStateClass() {
      switch (this.reviewItem.action) {
        case 'transfer':
          return 'organization-owner-card__header--transfer';
        case 'leave':
          return 'organization-owner-card__header--leave';
        case 'delete':
          return 'organization-owner-card__header--delete';
        default:
          return '';
      }
    },
    pillStateClass() {
      switch (this.reviewItem.action) {
        case 'transfer':
          return 'organization-owner-pill__owners-bg-transfer';
        case 'leave':
          return 'organization-owner-pill__owners-bg-leave';
        case 'delete':
          return 'organization-owner-pill__owners-bg-delete';
        default:
          return '';
      }
    },
  },
  methods: {},
};
</script>

<style scoped lang="stylus">
.organization-owner-card {
  text-align: left;
  border: 1px solid #cccccc;
  border-radius: 10px;
  padding: 16px;
  background: #ffffff;
}

.organization-owner-card__header {
  color: #013D52;
}

.organization-owner-card__title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: inherit;
}

.organization-owner-card__icon {
  color: inherit;
  font-size: 18px;
  line-height: 1;
}

.organization-owner-card__meta-row {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.organization-owner-card__meta {
  margin: 0;
  font-size: 14px;
  color: #013D52;
}

.organization-owner-card__header--transfer {
  color: #013D52;
}

.organization-owner-card__header--delete {
  color: #d00a00;
}

.organization-owner-card__header--leave {
  color: #0f7d40;
}

.organization-owner-card__pill {
  margin-left: auto;
  flex-shrink: 0;
  vertical-align: center;
  gap: 8px;
}

.organization-owner-pill__owners-bg-transfer {
  color: #013d52;
  background: #E0EFF2;
}

.organization-owner-pill__owners-bg-leave {
  color: #0f7d40;
  background: #E0EFF2;
}

.organization-owner-pill__owners-bg-delete {
  color: #d00a00;
  background: #F7E0DF;
}

.organization-owner-card__owners-label {
  margin: 0;
  flex-shrink: 0;
}

.organization-owner-card__meta__info {
  display: flex;
  margin-left: auto;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  font-size: 14px;
  color: #555;
  line-height: 0;
}

.organization-owner-card__actions {
  font-size: 18px;
  color: #555;
}
</style>
